export default "__VITE_ASSET__CEvPvSmf__"